import TeamSlider from '../../TeamSlider';

const Lawyer = ({lawyerSection}) => {
  return (
    <div className="section__lawyer">
      <div className="section__lawyer__container">
        <h2>{lawyerSection?.title}</h2>
        <p className="subtitle_1">{lawyerSection?.subtitle}</p>
        <div className="section__lawyer__slider">
          <TeamSlider />
        </div>
      </div>
    </div>
  );
};

export default Lawyer;
